export default __webpack_public_path__ + "static/media/rides-page1400.b3777249.jpg";